import { REACT_APP_CAPTCHA_ENABLED, REACT_APP_RECAPTCHA_SITE_KEY } from '../../configs/settings/environment'

/**
 * To initialize recaptcha.
 */
export const initializeRecaptcha = () => {
  if (REACT_APP_CAPTCHA_ENABLED !== 'true') return

  const existingScript = document.querySelector(`script[src*="recaptcha/enterprise.js"]`)

  if (existingScript) {
    console.info('[reCAPTCHA] Script already loaded')
    return
  }

  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${REACT_APP_RECAPTCHA_SITE_KEY}`
  script.async = true
  script.defer = true
  script.onload = () => {
    console.info('[reCAPTCHA] Script loaded successfully')
  }
  script.onerror = () => {
    console.error('[reCAPTCHA] Failed to load script from Google')
  }
  document.body.appendChild(script)
}

/**
 * Custom hook to get a recaptcha token.
 */
export const useRecaptcha = (action = 'rfi_engine') => {
  const executeRecaptcha = () => {
    return new Promise(resolve => {
      if (REACT_APP_CAPTCHA_ENABLED !== 'true') {
        return resolve('')
      }

      const isRecaptchaLoaded =
        typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.enterprise?.execute === 'function'

      if (isRecaptchaLoaded) {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(REACT_APP_RECAPTCHA_SITE_KEY, {
              action
            })
            .then(token => {
              console.info('[reCAPTCHA] Token received successfully')
              resolve(token)
            })
            .catch(err => {
              console.error('[reCAPTCHA] Error while executing token:', err)
              resolve('')
            })
        })
      } else {
        console.warn('[reCAPTCHA] grecaptcha not loaded or execute method missing')
        resolve('')
      }
    })
  }

  return {
    executeRecaptcha
  }
}
